import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  limit_games_tirages: {
    count: 0,
    data: [],
    num_pages: 1,
    page: 1,
    page_size: "5",
  },
};

const slice = createSlice({
  name: "limitgametirage",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET LIMIT GAME TIRAGE
    getLimitGameTirageSuccess(state, action) {
      state.isLoading = false;
      state.limit_games_tirages = action.payload;
    },

    // ADD LIMIT GAME TIRAGE
    addLimitGameTirageSuccess(state, action) {
      const limitgametirage = action.payload;
      state.limit_games_tirages.data.push(limitgametirage);
      state.limit_games_tirages.count += 1;
    },

    // UPDATE LIMIT GAME TIRAGES
    updateLimitGameTirageSuccess(state, action) {
      const limitgametirage = action.payload;
      if (state.limit_games_tirages && state.limit_games_tirages.data) {
        const limitgametirageIndex = state.limit_games_tirages?.data?.findIndex(
          (obj) => obj.id === limitgametirage.id
        );
        if (limitgametirageIndex !== -1) {
          state.isLoading = false;
          state.limit_games_tirages.data[limitgametirageIndex] = limitgametirage;
        }
      } else {
        state.limit_games_tirages = { data: [] };
        state.limit_games_tirages.data.push(limitgametirage);
      }
    },

    // DELETE LIMIT GAME TIRAGE
    deleteLimitGameTirageSuccess(state, action) {
      const deletedLimitGameTirageId = action.payload;
      state.limit_games_tirages.data = state.limit_games_tirages.data.filter(
        (limitgametirage) => limitgametirage.id !== deletedLimitGameTirageId
      );
      state.isLoading = false;
    },

    // DELETE LIMIT GAME TIRAGES
    deleteLimitGameTiragesSuccess(state, action) {
      const deletedLimitGameTirageIds = action.payload;
      state.limit_games_tirages.data = state.limit_games_tirages.data.filter(
        (limitgametirage) => !deletedLimitGameTirageIds.includes(limitgametirage.id)
      );
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  addLimitGameTirageSuccess,
  updateLimitGameTirageSuccess,
  deleteLimitGameTirageSuccess,
  deleteLimitGameTiragesSuccess,
} = slice.actions;

// ----------------------------------------------------------------------

export function getLimitGameTirages(page = 1, rowsPerPage = 5) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/dashboard/limit-game-tirage?page=${page}&page_size=${rowsPerPage}`
      );
      dispatch(slice.actions.getLimitGameTirageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function getLimitGameTirage(keyId) {
  const response = await axios.get(
    `/api/dashboard/limit-game-tirage-id?keyId=${keyId}`
  );
  return response.data;
}

export async function addLimitGameTirage(data) {
  const response = await axios.post(`/api/dashboard/limit-game-tirage`, data);
  return response.data;
}

export async function updateLimitGameTirage(data) {
  const response = await axios.put(`/api/dashboard/limit-game-tirage`, data);
  return response.data;
}

export async function deleteLimitGameTirage(keyId) {
  const response = await axios.delete(`/api/dashboard/limit-game-tirage/${keyId}/`);
  return response.data;
}


export async function deleteLimitGameTirages(keyIds) {
  const response = await axios.delete(`/api/dashboard/limit-game-tirage-id`, {
    data: { keyIds },
  });
  return response.data;
}
